export const appKey = "ff-mcu";
export const appName = "My Chimney Users";
export const appRelease = "Continuously";

export const appInfo = {
  key: appKey,
  name: appName,
  release: appRelease,
};
